module.exports = __webpack_public_path__ + "img/brand-logo3.fcac1f4c.png";